import { computed, observable } from 'mobx';
import { BaseBlock } from '~/models/blocks/base-block.model';
import { IInvoiceColumnHeaderBlockResponse } from '~/types/server.types';
import { IInvoiceColumnHeaderBlockStyles } from '~/types/block-styles.types';
import type { InvoiceServiceItemBlock } from '~/models/blocks/invoice-service-item-block.model';
import type { FlowRevision } from '~/models/flow-revision.model';
import type { RootStore } from '~/stores/root.store';

type InvoiceColumnHeaderBlockDataForServer = ReturnType<
    BaseBlock['getDataForServer']
> &
    Pick<IInvoiceColumnHeaderBlockResponse, 'type'>;

export class InvoiceColumnHeaderBlock extends BaseBlock {
    type: 'invoice_column_header_block';
    @observable styles: IInvoiceColumnHeaderBlockStyles;

    constructor(
        block: IInvoiceColumnHeaderBlockResponse,
        flowRevision: FlowRevision<RootStore>,
        rootStore: RootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    isDraggable() {
        return false;
    }

    dndAcceptedTypes() {
        return null;
    }

    get isDeletable() {
        return false;
    }

    @computed
    get shouldExpandOnSelect() {
        return false;
    }

    @computed
    get invoiceBlock() {
        return this.flow.invoiceContainerBlock;
    }

    @computed
    get invoiceServicesBlock() {
        return this.invoiceBlock.invoiceServicesBlock;
    }

    @computed
    get serviceItems(): InvoiceServiceItemBlock[] {
        return this.invoiceBlock.invoiceServicesBlock.childBlocks.reduce(
            (serviceItems, childBlock) => {
                if (childBlock.type === 'invoice_service_item_block') {
                    serviceItems.push(
                        ...(childBlock as InvoiceServiceItemBlock).childBlocks
                    );
                    serviceItems.push(childBlock as InvoiceServiceItemBlock);
                }
                return serviceItems;
            },
            []
        );
    }

    getDataForServer(): InvoiceColumnHeaderBlockDataForServer {
        return {
            ...super.getDataForServer(),
            type: this.type as 'invoice_column_header_block'
        };
    }
}
